// extracted by mini-css-extract-plugin
export default {"slide-container":"Slideshow_slide-container__w4j7W"};